export default {
  members: 'Members of the team',
  newTeamMember: 'Creating new team member',
  title: 'Team management',
  totalMembers: 'Total members',
}
